import type {
  AdminVisitUpdateDraft,
  CheckinDraft,
  CheckinFieldErrors,
  CheckoutFieldErrors,
} from "../types/domain";

function normalizeWhitespace(value: string) {
  return value.replace(/\s+/g, " ").trim();
}

function validateRequiredText(
  value: string,
  label: string,
  minLength = 2,
  maxLength = 80,
) {
  const normalized = normalizeWhitespace(value);

  if (!normalized) {
    return `${label} è obbligatorio.`;
  }

  if (normalized.length < minLength) {
    return `${label} deve contenere almeno ${minLength} caratteri.`;
  }

  if (normalized.length > maxLength) {
    return `${label} non può superare ${maxLength} caratteri.`;
  }

  return "";
}

export function sanitizePersonText(value: string) {
  return normalizeWhitespace(value);
}

export function validateCheckinDraft(draft: CheckinDraft): CheckinFieldErrors {
  const errors: CheckinFieldErrors = {};

  const firstNameError = validateRequiredText(draft.firstName, "Il nome");
  const lastNameError = validateRequiredText(draft.lastName, "Il cognome");
  const companyError = validateRequiredText(draft.company, "L'azienda", 2, 120);

  if (firstNameError) {
    errors.firstName = firstNameError;
  }

  if (lastNameError) {
    errors.lastName = lastNameError;
  }

  if (companyError) {
    errors.company = companyError;
  }

  if (!draft.signatureDataUrl) {
    errors.signature = "La firma è obbligatoria.";
  }

  if (draft.privacyAccepted !== true) {
    errors.privacyAccepted =
      "Devi accettare la Privacy Policy per confermare l'ingresso.";
  }

  if (draft.emergencyPlanAccepted !== true) {
    errors.emergencyPlanAccepted =
      "Devi confermare che il piano di emergenza è stato illustrato.";
  }

  return errors;
}

export function validateCheckoutSelection(
  selectedVisitId: string,
  signatureDataUrl: string,
): CheckoutFieldErrors {
  const errors: CheckoutFieldErrors = {};

  if (!selectedVisitId) {
    errors.selectedVisitId = "Seleziona il visitatore da registrare in uscita.";
  }

  if (!signatureDataUrl) {
    errors.signature = "La firma è obbligatoria.";
  }

  return errors;
}

export function validateAdminVisitDraft(draft: AdminVisitUpdateDraft) {
  const errors: Partial<Record<keyof AdminVisitUpdateDraft, string>> = {};

  const firstNameError = validateRequiredText(draft.firstName, "Il nome");
  const lastNameError = validateRequiredText(draft.lastName, "Il cognome");
  const companyError = validateRequiredText(draft.company, "L'azienda", 2, 120);

  if (firstNameError) {
    errors.firstName = firstNameError;
  }

  if (lastNameError) {
    errors.lastName = lastNameError;
  }

  if (companyError) {
    errors.company = companyError;
  }

  if (!draft.checkinAtLocal) {
    errors.checkinAtLocal = "L'orario di arrivo è obbligatorio.";
  }

  return errors;
}
